import { format } from 'date-fns/fp';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';

import { formatCurrency, getCurrencyIcon } from '../../../lib/currencyUtils';
import { CompensationScheme, Currency } from '../../../lib/enum';
import { AffiliateDebitTransactionItem } from '../../../lib/types';

interface DebitTransactionRowProps {
  transaction: AffiliateDebitTransactionItem;
  currency?: Currency;
}

const DebitTransactionRow = ({ transaction, currency }: DebitTransactionRowProps) => {
  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      color: '#6B7280',
      fontWeight: 400,
      fontSize: '14px'
    },
    [`&.${tableCellClasses.body}`]: {
      border: 'none',
      fontSize: '14px',
      color: '#111827',
      padding: '16px 8px'
    }
  }));

  const transactionDate = format('dd/MM/yyyy HH:mm a')(new Date(transaction.transactionDate));

  const formatAmount = () => {
    if (!currency) return transaction.amount.toString();
    try {
      return formatCurrency(transaction.amount, currency);
    } catch {
      return `${transaction.amount} ${currency}`;
    }
  };

  const renderAmountWithIcon = () => {
    if (!currency || transaction.amount === 0) return transaction.amount.toString();

    const formattedAmount = formatAmount();
    const currencyIcon = getCurrencyIcon(currency, 'small');

    if (currencyIcon && currency === Currency.SAR) {
      const IconComponent = currencyIcon;
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <IconComponent color="currentColor" />
          <span>{formattedAmount.replace('SAR', '').trim()}</span>
        </Box>
      );
    }

    return formattedAmount;
  };

  const formatTransactionType = () => {
    switch (transaction.transactionType) {
      case CompensationScheme.SUBSCRIPTION_CREDIT:
        return 'Subscription Credit';
      case CompensationScheme.PAYOUT:
        return 'Payout';
      default:
        return transaction.transactionType;
    }
  };

  return (
    <TableRow>
      <StyledTableCell>{formatTransactionType()}</StyledTableCell>
      <StyledTableCell>
        <Typography sx={{ color: '#57AE7F', fontWeight: 500 }}>
          {transaction.transactionType.toUpperCase()}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>{transaction.transactionRefId || 'N/A'}</StyledTableCell>
      <StyledTableCell>{transactionDate}</StyledTableCell>
      <StyledTableCell>{renderAmountWithIcon()}</StyledTableCell>
    </TableRow>
  );
};

export default DebitTransactionRow;


